import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FicheIntervention} from 'app/models/ficheIntervention.model';
import {FicheInterventionService} from 'app/services/fiche-intervention.service';
import {formatDate} from '@angular/common';
import {WorkOrder} from '../../../../models/workOrder.model';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ModalPhotoComponent} from '../photo/modal-photo.component';
import {PhotoLieu} from '../../../../models/photoLieu.model';
import {DossierInterventionService} from '../../../../services/dossier_intervention.service';
import {Piece} from '../../../../models/piece.model';
import {ModalWorkOrderComponent} from '../work-order/modal-work-order.component';
import {WorkOrderTypeService} from '../../../../services/work-order-type.service';
import {WorkOrderType} from '../../../../models/workOrderType.model';
import {WorkOrderService} from '../../../../services/work-order.service';

@Component({
    selector: 'app-edit-fiche-intervention',
    templateUrl: './edit-fiche-intervention.component.html',
    styleUrls: ['./edit-fiche-intervention.component.scss']
})
export class EditFicheInterventionComponent implements OnInit {
    currentFicheIntervention: FicheIntervention = new FicheIntervention();
    idDossierIntervention: number;

    isPiecesLoaded: boolean = false;
    pieces: Piece[] = [];

    isFicheLoaded: boolean = false;
    unsavedChanges: boolean = false;
    workOrderTypes: WorkOrderType[];
    isWorkOrderTypesLoaded: boolean;

    isWorkOrdersLoaded: boolean = false;
    workOrders: WorkOrder[] = [];

    isNewFiche: boolean = false;

    get isLoaded(): boolean {
        return this.isPiecesLoaded &&
            this.isFicheLoaded &&
            this.isWorkOrderTypesLoaded &&
            this.isWorkOrdersLoaded;
    }
    constructor(
        private ficheInterventionService: FicheInterventionService,
        private dossierInterventionService: DossierInterventionService,
        private route: ActivatedRoute,
        private dialog: MatDialog,
        private workOrderTypesService: WorkOrderTypeService,
        private workOrdersService: WorkOrderService,
    ) {
    }

    ngOnInit(): void {
        this.getFicheIntervention();
        this.fetchWorkOrderTypes();

        const currentPath = window.location.pathname;

        if (currentPath.endsWith('/0')) {
            this.isNewFiche = true;
        }
    }

    getFicheIntervention(): void {
        this.route.params.subscribe((params) => {
            this.idDossierIntervention = params['idDossierIntervention'];
            if (parseInt(params['idFicheIntervention'], 10) === 0) {
                this.currentFicheIntervention = new FicheIntervention({
                    date_contact: formatDate(new Date(), 'yyyy-MM-dd', 'en'),
                    dossier_intervention_id: this.idDossierIntervention.toString()
                });
                this.fetchAll();
                this.isFicheLoaded = true;
            } else {
                this.ficheInterventionService.getFicheIntervention(params['idFicheIntervention']).subscribe((ficheIntervention) => {
                    this.currentFicheIntervention = ficheIntervention;
                    this.isFicheLoaded = true;
                    this.fetchAll();
                });
            }
        });
    }

    fetchAll(): void {
        this.fetchPieces();
        this.fetchWorkOrders();
    }

    fetchWorkOrderTypes(): void {
        this.workOrderTypesService.getWorkOrderTypes().subscribe((workOrderTypes) => {
            this.workOrderTypes = workOrderTypes;
            this.isWorkOrderTypesLoaded = true;
        });
    }

    fetchPieces(): void {
        this.dossierInterventionService.getPiecesForDossierIntervention(parseInt(this.currentFicheIntervention.dossier_intervention_id, 10)).subscribe((pieces) => {
            this.pieces = pieces;
            this.isPiecesLoaded = true;
        });
    }

    hasUnsavedChanges(): boolean {
        return this.unsavedChanges;
    }

    openTravauxModal(workOrder: WorkOrder = null): MatDialogRef<ModalWorkOrderComponent> {
        if (workOrder === null) {
            workOrder = new WorkOrder({
                fiche_intervention_id: this.currentFicheIntervention.id
            });
        }

        const dialogRef = this.dialog.open(ModalWorkOrderComponent, {
            width: '75%',
        });

        dialogRef.componentInstance.ficheIntervention = this.currentFicheIntervention;
        dialogRef.componentInstance.workOrder = workOrder;
        dialogRef.componentInstance.pieces = this.pieces;
        dialogRef.componentInstance.workOrderTypes = this.workOrderTypes;

        dialogRef.afterClosed().subscribe((result) => {
            this.fetchWorkOrders();
        });

        return dialogRef;
    }

    fetchWorkOrders(): void {
        this.workOrdersService.getWorkOrders(this.currentFicheIntervention.id).subscribe((workOrders) => {
            this.workOrders = workOrders;
            this.isWorkOrdersLoaded = true;
        });
    }
}
